import React, { useEffect, useState } from "react";
import { translate } from "../Services/translation";
import DealerCollapsible from "../Components/Dealer.Collapsible";
import {
  initMap,
  updateMap,
  clearUserMarker,
  calculateDistances,
  clearDistances,
} from "../Components/Dealer.Map";

const DealerContainer = ({ dealers, dealersEcom, defaultLocation }) => {
  const [dealerList, setDealerList] = useState(dealers);
  const [filter, setFilter] = useState({
    physical: true,
    ecom: true,
    ecomReq: true,
  });
  const [location, setLocation] = useState("");
  const [isLoaded, setIsLoaded] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [maxDistanceFilter, setMaxDistanceFilter] = useState(null);

  const getFilteredList = (list) => {
    const { physical, ecom, ecomReq } = filter;

    let filteredList = list.filter((dealer) => {
      return (
        (physical && dealer.StreetAdress) ||
        (ecom && dealer.IsEcom) ||
        (ecomReq && dealer.IsReqEcom)
      );
    });

    if (
      location &&
      filteredList.length != 0 &&
      filteredList.every((obj) => obj.hasOwnProperty("Distance")) &&
      maxDistanceFilter
    ) {
      filteredList = filteredList.filter(
        (dealer) => dealer.Distance.value < maxDistanceFilter
      );
    }

    return filteredList;
  };

  const onInputChange = (e) => {
    if (!e.target.value && location) {
      setLocation("");
      setMaxDistanceFilter(null);
      clearUserMarker(getFilteredList(dealerList));
    }
  };

  const onFilterRadioChange = (e) => {
    const targetKey = e.target.value;
    const updatedFilters = { ...filter };

    updatedFilters[targetKey] = !updatedFilters[targetKey];

    setFilter(updatedFilters);
  };

  const onDistanceRadioChange = (e) => {
    setMaxDistanceFilter(e.target.value);
  };

  useEffect(() => {
    isLoaded && updateMap(dealerList, getFilteredList(dealerList));
  }, [filter, maxDistanceFilter]);

  useEffect(() => {
    if (isLoaded && location) {
      calculateDistances(dealerList, setDealerList, setIsLoading);
    } else if (isLoaded && !location) {
      clearDistances(dealerList, setDealerList);
    }
  }, [location]);

  useEffect(() => {
    initMap(dealers, defaultLocation, setLocation, setIsLoaded, setDealerList);
  }, []);

  return (
    <div className="dealer">
      <div className="dealer-intro">
        <p className="mb-2">{translate("dealers.search-helptext")}</p>
        <div className="input-group mb-2">
          <input
            id="pac-input"
            type="text"
            placeholder={translate("dealers.placeholder")}
            className="form-control dealer-search border-end-0 py-2 px-4"
            onChange={(e) => onInputChange(e)}
          />
          <div className="input-group-append">
            <button
              className="btn border border-1 border-start-0 p-2"
              type="submit"
              id="pac-input-button"
            >
              <i className="bi bi-geo-alt-fill"></i>
            </button>
          </div>
        </div>
        <div className="dealer__filter-wrapper">
          <div className="form-check-inline">
            <label className="form-label">{translate("dealers.filter")}:</label>
          </div>
          <div className="form-check form-check-inline">
            <input
              className="form-check-input cursor-hover dealer-check"
              type="checkbox"
              id="physicalCheckbox"
              name="physicalCheckbox"
              value="physical"
              checked={filter.physical}
              onChange={(e) => onFilterRadioChange(e)}
            />
            <label
              className="form-check-label cursor-hover"
              htmlFor="physicalCheckbox"
            >
              {translate("dealers.physicalstore")}
              <i className="bi bi-house-door"></i>
            </label>
          </div>
          <div className="form-check form-check-inline">
            <input
              className="form-check-input cursor-hover dealer-check"
              type="checkbox"
              id="ecomCheckbox"
              name="ecomCheckbox"
              value="ecom"
              checked={filter.ecom}
              onChange={(e) => onFilterRadioChange(e)}
            />
            <label
              className="form-check-label cursor-hover"
              htmlFor="ecomCheckbox"
            >
              {translate("dealers.ecom")}
              <i className="bi bi-bag"></i>
            </label>
          </div>
          <div className="form-check form-check-inline">
            <input
              className="form-check-input cursor-hover dealer-check"
              type="checkbox"
              id="ecomReqCheckbox"
              name="ecomReqCheckbox"
              value="ecomReq"
              checked={filter.ecomReq}
              onChange={(e) => onFilterRadioChange(e)}
            />
            <label
              className="form-check-label cursor-hover"
              htmlFor="ecomReqCheckbox"
            >
              {translate("dealers.ecom-req")}
              <i className="bi bi-lock-fill"></i>
            </label>
          </div>
        </div>

        <div className="dealer__filter-wrapper">
          {location && (
            <>
              <div className="form-check-inline">
                <label className="form-label">
                  {translate("dealers.max-distance")}:
                </label>
              </div>
              <div className="form-check form-check-inline">
                <input
                  className="form-check-input cursor-hover dealer-check"
                  type="checkbox"
                  id="max-distance-none"
                  name="max-distance-none"
                  value={undefined}
                  checked={!maxDistanceFilter}
                  onChange={(e) => onDistanceRadioChange(e)}
                />
                <label
                  className="form-check-label cursor-hover"
                  htmlFor="max-distance-none"
                >
                  {translate("dealers.max-distance-none")}
                </label>
              </div>
              <div className="form-check form-check-inline">
                <input
                  className="form-check-input cursor-hover dealer-check"
                  type="checkbox"
                  id="max-distance-10000"
                  name="max-distance-10000"
                  value={10000}
                  checked={maxDistanceFilter == 10000}
                  onChange={(e) => onDistanceRadioChange(e)}
                />
                <label
                  className="form-check-label cursor-hover"
                  htmlFor="max-distance-10000"
                >
                  {translate("dealers.max-distance-10000")}
                </label>
              </div>
              <div className="form-check form-check-inline">
                <input
                  className="form-check-input cursor-hover dealer-check"
                  type="checkbox"
                  id="max-distance-30000"
                  name="max-distance-30000"
                  value={30000}
                  checked={maxDistanceFilter == 30000}
                  onChange={(e) => onDistanceRadioChange(e)}
                />
                <label
                  className="form-check-label cursor-hover"
                  htmlFor="max-distance-30000"
                >
                  {translate("dealers.max-distance-30000")}
                </label>
              </div>
              <div className="form-check form-check-inline">
                <input
                  className="form-check-input cursor-hover dealer-check"
                  type="checkbox"
                  id="max-distance-50000"
                  name="max-distance-50000"
                  value={50000}
                  checked={maxDistanceFilter == 50000}
                  onChange={(e) => onDistanceRadioChange(e)}
                />
                <label
                  className="form-check-label cursor-hover"
                  htmlFor="max-distance-50000"
                >
                  {translate("dealers.max-distance-50000")}
                </label>
              </div>
            </>
          )}
        </div>
      </div>
      <div className="dealer__main">
        <div className="dealer__half">
          <h5 className="text-uppercase">
            {translate("dealers.your-location")}:{" "}
            {location ? location : translate("dealers.location-not-set")}
          </h5>
          {dealerList && (
            <div className="dealer__physical-list-wrapper">
              <h4 className="text-uppercase">
                {translate("dealers.physical-stores")}
              </h4>
              <div
                className="dealer__physical-list"
                style={{ overflowY: isLoading ? "hidden" : "auto" }}
              >
                {isLoading && (
                  <div className="dealer__physical-list--loading-wrapper">
                    <div className="dealer__physical-list--loading">
                      <i className="bi bi-hourglass-split h1"></i>
                      <h2>{translate("general.loading")}</h2>
                    </div>
                  </div>
                )}
                {getFilteredList(dealerList).map((dealer) => (
                  <DealerCollapsible
                    dealer={dealer}
                    key={dealer.DealerNumber}
                  />
                ))}
                {getFilteredList(dealerList).length < 1 && (
                  <h6>{translate("dealers.no-results")}.</h6>
                )}
              </div>
            </div>
          )}
          {dealersEcom.length != 0 && (filter.ecom || filter.ecomReq) && (
            <>
              <h4 className="text-uppercase">
                {translate("dealers.ecom-only")}
              </h4>
              {dealersEcom.map((dealer) => (
                <DealerCollapsible dealer={dealer} key={dealer.DealerNumber} />
              ))}
            </>
          )}
        </div>
        <div className="dealer__half">
          <div id="map" className="dealer__map"></div>
        </div>
      </div>
    </div>
  );
};

export default DealerContainer;
